import { makeStyles } from "@material-ui/core";

export const storageHeaderStyles = makeStyles((theme) => ({
    wrapper: {
        padding: '1em'
    },
    column: {
        marginTop: '2em',
        color: theme.palette.primary.main,
        fontWeight: 'bold'
    }
}));